import { mapApiImageToImageProps } from './common.mappers';

import type {
  FBlogHomeTemplateBlogPostCard,
  FBlogHomeTemplateProps,
} from '@/components/templates/FBlogHomeTemplate.vue';

export function mapApiDataToBlogHome(
  blogHomeRawData: StrapiResponseData<BlogPostContentType>[] | undefined,
  audiencesRawData: StrapiResponseData<AudienceContentType>[] | undefined,
  topicsRawData: StrapiResponseData<TopicContentType>[] | undefined,
  guidesRawData: StrapiResponseData<GuideContentType>[] | undefined
): FBlogHomeTemplateProps {
  return {
    blogPostCards: mapApiDataToBlogHomeBlogPosts(blogHomeRawData),
    audiences: mapApiDataToBlogHomeAudiences(audiencesRawData),
    topics: mapApiDataToBlogHomeTopics(topicsRawData),
    guideCards: mapApiDataToBlogHomeGuides(guidesRawData),
  };
}

function mapApiDataToBlogHomeBlogPosts(
  blogHomeRawData: StrapiResponseData<BlogPostContentType>[] | undefined
): FBlogHomeTemplateBlogPostCard[] {
  return (blogHomeRawData ?? []).map(card => ({
    text: card.attributes?.title || '',
    image: mapApiImageToImageProps(
      card.attributes?.main_image?.data?.attributes,
      'medium'
    ),
    link: {
      location: `/resources/blog/${card.attributes?.slug}`,
    },
    linkText: '',
    audiences: (card.attributes?.audiences?.data || []).map(audience => ({
      name: audience.attributes.name,
      id: audience.id,
    })),
    topics: [
      ...(card.attributes?.other_topics?.data || []).map(topic => ({
        name: topic?.attributes?.name,
        id: topic?.id,
      })),
      {
        name: card.attributes?.main_topic?.data?.attributes?.name,
        id: card.attributes?.main_topic?.data?.id,
      },
    ].filter((topic): topic is { name: string; id: number } => Boolean(topic)),
  }));
}

function mapApiDataToBlogHomeAudiences(
  audiencesRawData: StrapiResponseData<AudienceContentType>[] | undefined
): FBlogHomeTemplateProps['audiences'] {
  return (audiencesRawData || []).map(audience => ({
    label: audience.attributes.name,
    value: audience.id,
  }));
}

function mapApiDataToBlogHomeTopics(
  topicsRawData:
    | (StrapiResponseData<TopicContentType> | undefined)[]
    | undefined
): FBlogHomeTemplateProps['topics'] {
  return (topicsRawData || []).filter(Boolean).map(topic => ({
    label: topic?.attributes?.name ?? '',
    value: topic?.id ?? -1,
  }));
}

function mapApiDataToBlogHomeGuides(
  guidesRawData: StrapiResponseData<GuideContentType>[] | undefined
): FBlogHomeTemplateProps['guideCards'] {
  return (guidesRawData ?? []).map(card => ({
    title: card.attributes.title ?? '',
    excerpt: card.attributes.excerpt ?? '',
    buttonLocation: `/resources/guides/${card.attributes.slug}`,
    buttonText: '',
    audience: card.attributes.audience?.data
      ? {
          name: card.attributes.audience?.data?.attributes.name ?? '',
          id: card.attributes.audience?.data?.id,
        }
      : null,
    topics: (card.attributes.topics?.data || []).map(topic => ({
      name: topic?.attributes?.name ?? '',
      id: topic?.id ?? -1,
    })),
  }));
}
